import {
  ALL_LANGUAGES,
  Language,
} from '../enums/language.enum';

export const DEFAULT_LANG_KEY = Language.de;
const LANG_STORAGE_KEY = 'preferredLang';

export function getActualLanguage(): string {
  const storedLang = localStorage.getItem(LANG_STORAGE_KEY);
  if (ALL_LANGUAGES.includes(storedLang as Language)) {
    return storedLang as Language;
  }
  const browserLang = navigator.language.split('-')[0]; // 'en-US' -> 'en'
  return ALL_LANGUAGES.includes(browserLang as Language) ? browserLang : DEFAULT_LANG_KEY;
}

export function saveLang(lang: Language): void {
  localStorage.setItem(LANG_STORAGE_KEY, lang);
}
